import { render, staticRenderFns } from "./AdminReports.vue?vue&type=template&id=9d8ae0e4&scoped=true"
import script from "./AdminReports.vue?vue&type=script&lang=js"
export * from "./AdminReports.vue?vue&type=script&lang=js"
import style0 from "./AdminReports.vue?vue&type=style&index=0&id=9d8ae0e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d8ae0e4",
  null
  
)

export default component.exports